import { AxiosInstance, AxiosError } from 'axios';
import logger from '../../utils/logger';

/**
 * Error logging interceptor with error code and message.
 */
const logErrors = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      const { response, message, code } = error;

      if (!response) {
        // Network errors (connection issues, timeouts, etc.)
        const errorCode = code || 'NETWORK_ERROR';
        logger('error', `Network Error [${errorCode}]: ${message}`);
      } else {
        // Only log 5xx server errors
        const { status } = response;
        if (status >= 500) {
          logger('error', `Server Error [${status}]: ${message}`);
        }
      }

      return Promise.reject(error);
    },
  );

  return axiosInstance;
};

export default logErrors;
